import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';

import { rem } from '../../utils';

export const StyledSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;

export const AntSelectWrapper = styled.div`
  width: 100%;
  height: ${({ theme }) => rem(theme.Form.InputSize.Medium.height)};

  & .ant-select {
    width: 100% !important;
  }
  & .ant-select-selection-item {
    font-weight: ${({ theme }) => theme.Typography.FontWeight.Medium} !important;
    color: ${({ theme }) => theme.Color.Neutrals.Text} !important;
  }
  & .ant-select .ant-select-arrow {
    margin-top: -3px;
  }
  & .ant-select-selector {
    padding: 0 ${({ theme }) => rem(theme.Spacing.Size.XSmall)} !important;
    height: ${({ theme }) => rem(theme.Form.InputSize.Medium.height)} !important;
    background: inherit !important;
    box-shadow: none !important;
    border: ${({ theme }) => `1px solid ${theme.Color.Neutrals.Border}`} !important;
    border-radius: ${({ theme }) => rem(theme.Border.Radius.Small)} !important;

    /* Enhanced focus state for better selected collection visibility */
    &:hover,
    &:focus {
      border-color: ${({ theme }) => theme.Color.Brand.Primary} !important;
    }
  }

  /* Show selected value more prominently */
  &.ant-select-focused .ant-select-selector {
    border-color: ${({ theme }) => theme.Color.Brand.Primary} !important;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.Color.Brand.Light} !important;
  }
`;

export const GlobalSelectStyles = createGlobalStyle`
  .ant-select-dropdown {
    ${({ theme }) => theme.Scrollbar.Default};
    box-shadow: 0 0 8px 0 ${({ theme }) => theme.Color.Overlay.Light} !important;
      background: ${({ theme }) => theme.Components.Panel.Background} !important;


    /* Add hover state for dropdown items */
    .ant-select-item-option:hover:not(.ant-select-item-option-disabled) {
      background-color: ${({ theme }) => theme.Components.Panel.BackgroundHover} !important;
    }

    /* Fix selected state to show proper visual indication */
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      background-color: ${({ theme }) => theme.Color.Brand.Lightest} !important;
      color: ${({ theme }) => theme.Color.Brand.Primary} !important;
      font-weight: ${({ theme }) => theme.Typography.FontWeight.Medium} !important;
    }

    /* Active state (keyboard navigation) */
    .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
      background-color: ${({ theme }) => theme.Components.Panel.BackgroundHover} !important;
    }

    /* Ensure selected item maintains its appearance even when active */
    .ant-select-item-option-selected.ant-select-item-option-active:not(.ant-select-item-option-disabled) {
      background-color: ${({ theme }) => theme.Color.Brand.Lightest} !important;
      color: ${({ theme }) => theme.Color.Brand.Primary} !important;
    }

    .ant-select-single.ant-select-open .ant-select-selection-item {
      color: ${({ theme }) => theme.Color.Neutrals.Text} !important;
    }

    .ant-select-item-option-content {
      font-weight: 500 !important;
      background: inherit !important;
    }
  }
`;

export const StyledLabel = styled.label`
  display: flex;
  width: 100%;
  align-items: flex-start;
  padding: 0 0 ${({ theme }) => rem(theme.Spacing.Size.XSmall)} 0;
`;
